import { z } from '@betty/toolkit/api';

export const GameImageVariantSchema = z.enum([
  'portrait',
  'square',
  'landscape',
  'custom',
]);

export const GameImageUrlSchema = z.object({ url: z.string().url() });

export const GameImageSchema = z.record(
  GameImageVariantSchema,
  GameImageUrlSchema,
);

export const DisplayFeaturesSchema = z.object({
  ComingSoon: z
    .object({
      validUntil: z.string().datetime(),
    })
    .optional(),
  IsUnderMaintenance: z.object({}).optional(),
  Favorite: z.object({}).optional(),
});

export const GameSchema = z.object({
  id: z.number().or(z.string()),
  name: z.string(),
  provider: z.string(),
  providerId: z.number(),
  subprovider: z.string().optional(),
  subproviderId: z.number(),
  displayFeatures: DisplayFeaturesSchema,
  gameImages: GameImageSchema,
  // tags: z.array(z.string()),
  hasCoinsGameplay: z.boolean(),
});

export const GameItemSchema = z.record(z.string(), GameSchema);

export const GamesResponseSchema = z.object({
  games: GameItemSchema,
});

export const SearchResultsSchema = z.object({
  gameIds: z.array(z.number()),
});

export const GameInfoImageSchema = z.object({
  name: z.string(),
  url: z.string(),
});

export const GameInfoSchema = z.object({
  id: z.number(),
  name: z.string(),
  minBet: z.number(),
  maxBet: z.number(),
  reelsCount: z.number().optional(),
  linesCount: z.number().optional(),
  returnToPlayerPercentage: z.number(),
  description: z.string(),
  images: z.array(GameInfoImageSchema),
});
